import type {FormSelectFieldOption} from '#lit/components/base/form_select_field/index.js';
import {DestinationLocale} from '#lit/common/locale/destination.js';
import {locale} from '#lit/common/locale/index.js';

export enum CampaignType {
  NEW = 'New',
  EXISTING = 'Existing',
}

export enum QualtricsListType {
  XM_DIRECTORY = 'XM Directory',
  MAILING_LIST = 'Mailing List',
}

export enum MarketoAudienceType {
  STATIC_LIST = 'static_list',
  CUSTOM_OBJECT = 'custom_object',
}

export const MarketoAudienceTypes: FormSelectFieldOption[] = [
  {label: 'Static List', value: MarketoAudienceType.STATIC_LIST},
  {label: 'Custom Object', value: MarketoAudienceType.CUSTOM_OBJECT},
];

export enum SailthruApiType {
  USERS_API = 'users_api',
  JOBS_API = 'jobs_api',
}

export const SailthruApiTypes: FormSelectFieldOption[] = [
  {
    label:
      DestinationLocale[locale.current].exportForm.sailthru.apiType.usersLabel,
    value: SailthruApiType.USERS_API,
  },
  {
    label:
      DestinationLocale[locale.current].exportForm.sailthru.apiType.jobsLabel,
    value: SailthruApiType.JOBS_API,
  },
];

// Treat this value as an empty option value for some select fields
export const EmptyOptionValue = '-1';

export enum SyncEndValues {
  YES = 'yes',
  NO = 'no',
}

export const CampaignTypeOptions: FormSelectFieldOption[] = [
  {label: CampaignType.NEW, value: CampaignType.NEW},
  {label: CampaignType.EXISTING, value: CampaignType.EXISTING},
];

export const PulsePointProducts: FormSelectFieldOption[] = [
  {label: 'LIFE', value: 'LIFE'},
];

export const QualtricsListTypes: FormSelectFieldOption[] = [
  /*
  * Commented out as Bifrost does not support XM Directory for now
  {
    label: QualtricsListType.XM_DIRECTORY,
    value: QualtricsListType.XM_DIRECTORY,
  },
  */
  {
    label: QualtricsListType.MAILING_LIST,
    value: QualtricsListType.MAILING_LIST,
  },
];

export const ViantSegmentIdTypes: FormSelectFieldOption[] = [
  {label: 'Userpool', value: 'Userpool'},
  {label: 'Taxonomy', value: 'Taxonomy'},
  {label: 'Third Party', value: 'Third Party'},
];
